/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Open_TrashInputs */

const cs_documents_open_trash = /** @type {(inputs: Documents_Open_TrashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koš`)
};

const en_documents_open_trash = /** @type {(inputs: Documents_Open_TrashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trash`)
};

/**
* | output |
* | --- |
* | "Trash" |
*
* @param {Documents_Open_TrashInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_open_trash = /** @type {((inputs?: Documents_Open_TrashInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Open_TrashInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_open_trash(inputs)
	return cs_documents_open_trash(inputs)
});